import React from 'react';
import '../../styles/roboticsProduct.css'
import AnimatedArrowButton from '../AnimatedArrowButton';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import product1 from '../../assets/h9.png';
import product2 from '../../assets/h8.png';
import product3 from '../../assets/h7.png';
import product4 from '../../assets/h3.png';
import bgimage from '../../assets/half-circle.png';

const HorecaProducts1= () => {

    const sliderSettings = {
        infinite: true,
        slidesToShow: 4,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 2000,
        arrows:false,
        pauseOnHover: true,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 3,
            },
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 2,
            },
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
            },
          },
        ],
      };

      const cards = [
        { name: 'Granny Smith Apples', company: "Crisp, tart, and perfect for snacking or baking." , image:product1  },
        { name: 'Baby Spinach Leaves', company: "Tender and fresh, packed with nutrients." , image:product3  },
        { name: 'Cherry Tomatoes', company: "Sweet and juicy, ideal for salads and garnishes." , image:product2 },
        { name: 'Italian Basil', company: "Aromatic and flavorful, perfect for sauces and garnishes." , image:product4 }, 
        
      ];

    return(<div  className='roboticsproduct mt-5 pb-5 ' style={{height:'auto'}}>

        
            <div className='roboticsproduct-inner pt-4' >
            
            <h4 className='mx-3' style={{color:'#FFD52B',textAlign:'center'}}>Products</h4>
            <hr></hr>
            
            <div className='myservices' style={{display:'flex',padding:'25px',gap:'10px',paddingTop:"2rem", width:'100%',paddingBottom:'1rem'}}>
                        
                        <div className='services-msg' style={{textAlign:'left', width:'100%'}}>
                            <div style={{display:'flex' , alignItems:'start', justifyContent:'space-between', width:'100%'}}><h1 style={{fontWeight:"600"}}>Fresh Produce</h1> <div className='button1'></div> </div>
                            <p style={{color:'white', fontSize:"14px"}}>Savor the freshness of handpicked fruits, vibrant vegetables, and aromatic herbs.</p>
                            <div className='button2'> </div> 
                        </div>
            </div>
            <hr></hr>
            
            <div style={{  maxWidth: "90%", margin: "auto" }} className='mt-5'>
      <Slider {...sliderSettings}>
        {cards.map((card) => (
          <div key={card.id} style={{ padding: "10px"}}>
            <div
              style={{
                
                backgroundColor: "#0C0A00",
                border:'1px solid #383838',
                display: "flex",
                alignItems: "center",
                justifyContent: "start",
                borderRadius: "10px",
                marginLeft:"10px",
                marginRight:"10px",
                overflow:'hidden',
                
                flexDirection:'column',
                textAlign:'left'
              }}
              className='product-card'
            >
              <div style={{height:'150px',width:'100%', overflow:'hidden'}}>
                <img src={card.image} style={{objectFit:'cover',width:'100%', height:'100%'}}></img>
                

              </div>
              <div style={{padding:'1rem' ,height:'150px'}}>
              <h5 style={{width:'100%',marginTop:'1rem'}}>{card.name}</h5>
            <p style={{width:'100%', fontSize:'0.7rem', color:'white',paddingBottom:'0.9rem',marginBottom:'0.3rem'}}>{card.company}</p>
            </div>
            </div>
            
          </div>
        ))}
      </Slider>
    </div>
            

            </div>
        
    

    </div>);

}

export default HorecaProducts1;